export default __webpack_public_path__ + "static/media/folder-horizontal.c3be4846.png";